import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class EMISchemeFilter extends Component {
    state = {
         emiSchemeLists:[],
         emiSchemeValue:'',
    };
    componentDidMount(){
        this._getEmiScheme(this.props.start_date,this.props.end_date);
    }

    resetEMISchemeFilter(){
        this.setState({
        emiSchemeValue: [],
        })
    }

     _getEmiScheme(start_date, end_date){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-scheme-filter/',{
                yestSend: start_date,
                todSend: end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => { console.log(response);
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((scheme, index) => {
                    this.state.emiSchemeLists.push({value: scheme.scheme, label: scheme.scheme})
                });
            }
        });
    }
    changeEmiScheme(optionSelected) {
        let value = '';
        let schemeArray = [];
        if (optionSelected === null) {
            value = null;
        } else {
            optionSelected.map((mids, i) => {
                schemeArray.push(mids.value)
//                 var index = this.state.emiSchemeLists.findIndex(obj => obj.value==mids.value);
//                 this.state.emiSchemeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectEMIScheme(optionSelected, schemeArray);
//         var is_enable = compareValues(schemeArray, this.state.active_emiSchemeIDs);
        this.setState({
//             emiSchemeIDs:schemeArray,
            emiSchemeValue:optionSelected,
        });
        // this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
        //     this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, schemeArray);
    }

    render() {

        return (
            <ReactMultiSelectCheckboxes name="emi_scheme"
            isMulti
            value={this.state.emiSchemeValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeEmiScheme.bind(this)}
            options={this.state.emiSchemeLists}
            placeholderButtonLabel="Select [ EMI Scheme]"
        />
        );

    }
}
export default EMISchemeFilter;